export default {
  'memberPoint.title': 'Member Points',
  'memberPoint.loyalty.title': 'Campaign Points',
  'memberPoint.loyalty.name': 'Campaign Name',
  'memberPoint.detail': 'Details',
  'memberPoint.store': 'Store',
  'memberPoint.point': 'Points',
  'memberPoint.source': 'Source',
  'memberPoint.update_time': 'Earned Time',
  'memberPoint.deduct_time': 'Deduction Time',
  'memberPoint.expired_at': 'Expiration Time',
  'memberPoint.note': 'Note',
  'memberPoint.details': 'Description',
  'memberPoint.current_point': 'Current Accumulated Points',
  'memberPoint.issue_date': 'Issue Date',
  'memberPoint.date': 'Date Range',
  'memberPoint.expired': 'Expiring Soon',
  'memberPoint.case': 'Event',
  'memberPoint.receiver': 'Recipient',
  'memberPoint.transfer': 'Sender',
  'memberPoint.record': 'Points History',
  'memberPoint.benefit': 'Points Benefits',
} as Record<string, string>;
